// src/ItemVariantPackageForm.js ver 00b (UPDATED: QTY > 0 validation) Jan 13 2026 4:07pm SB119
// src/ItemVariantPackageForm.js ver 00a (FIXED: ItemVariantPackageName as separate generated state) Jan 13 2026 11:54am SB119
import React, { useState, useEffect, useCallback } from 'react'; // NEW: useCallback
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAuth } from './App';
import * as itemVariantPackageService from './api/itemVariantPackageService';
import * as itemVariantsService from './api/itemVariantsService';
import { ApiError } from './api/apiClient';

const initialItemVariantPackageState = {
    ItemVariantName: '',
    QTY: 0.00,
    UOM: 'Pack',
    Package: 'Pack',
    // REMOVED: ItemVariantPackageName from initial state
    ChefsRating: '3-Good quality',
    ChefsNotes: '',
    SKU: '',
    UPC: '',
    Status: 'Active',
};

// Allowed dropdown options (for frontend consistency) (UNCHANGED)
const itemVariantPackageStatuses = ['Active', 'Not-Active'];
const allowedChefsRatings = ['1-Exceptional quality', '2-Observably Better', '3-Good quality', '4-Just below good but okay', '5-Questionable to Poor'];
const allowedUnitPackagings = ['Pack', 'Bottle', 'Piece', 'Unit', 'Can', 'Carton', 'Bag', 'Sachet', 'Pouch', 'Bungkus', 'Tali'];
const allowedUnitPackagingUOMs = ['Gram', 'Kilogram', 'Milliliter', 'Liter', 'Ounce', 'Fluid ounce', 'Guhit'];


function ItemVariantPackageForm() {
    // const { tenantId, id: itemVariantPackageId, mode } = useParams();
    const { id: itemVariantPackageId, mode } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAuth();

    const [formData, setFormData] = useState(initialItemVariantPackageState);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const [itemVariantPackageNameError, setItemVariantPackageNameError] = useState(null); // This error state will now be handled by generatedNameError
    const [generatedNameError, setGeneratedNameError] = useState(null); // NEW: Dedicated error for generated name
    const [skuError, setSkuError] = useState(null);
    const [upcError, setUpcError] = useState(null);
    const [qtyError, setQtyError] = useState(null); // NEW ver 00b: State for QTY validation error

    const [itemVariantOptions, setItemVariantOptions] = useState([]);
    const [itemVariantLookupError, setItemVariantLookupError] = useState(null);

    const [generatedItemVariantPackageName, setGeneratedItemVariantPackageName] = useState(''); // NEW: Separate state for generated name


    // const isAdding = mode === 'add' || (!itemVariantPackageId && !mode);
    // const isEditing = mode === 'edit';
    // const isShowingDetails = mode === 'details';

    const isEditing = Boolean(itemVariantPackageId) && !location.pathname.includes('/item-variant-packages/details/');
    const isShowingDetails = Boolean(itemVariantPackageId) && location.pathname.includes('/item-variant-packages/details/');
    const isAdding = !isEditing && !isShowingDetails; // Is adding if no siteId and not in details mode

    console.log(`isAdding=${isAdding} isShowingDetails=${isShowingDetails} isEditing=${isEditing} `)

    const canEdit = auth.userProfile?.TenantProfileEditor === true;

    console.log(`canEdit=${canEdit}`)

    // Helper to construct ItemVariantPackageName (Memoized)
    const constructItemVariantPackageName = useCallback((itemVariantName, qty, uom, pkg) => {
        if (!itemVariantName || !qty || !uom || !pkg) return '';
        // Ensure QTY is formatted correctly for the generated name
        return `${itemVariantName}_${parseFloat(qty).toFixed(2)}_${uom}_${pkg}`.replace(/ /g, '_').toUpperCase();
    }, []);

    const tenantId = auth.userProfile?.SubsCoDocId; // re-added ver01. existing in ver 00a


    // NEW: Effect to update generated name whenever its parts change in formData
    useEffect(() => {
        setGeneratedItemVariantPackageName(
            constructItemVariantPackageName(
                formData.ItemVariantName,
                formData.QTY,
                formData.UOM,
                formData.Package
            )
        );
        // Clear generatedNameError if relevant fields change
        setGeneratedNameError(null);
    }, [formData.ItemVariantName, formData.QTY, formData.UOM, formData.Package, constructItemVariantPackageName]);


    useEffect(() => {
        const fetchData = async () => {
            if (!tenantId) {
                setError("Tenant ID missing.");
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);
            setItemVariantLookupError(null);

            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication required. Please log in.");
                    setLoading(false);
                    return;
                }

                const itemVariantsResponse = await itemVariantsService.getAllActiveItemVariantsForDropdown(tenantId, token);
                if (itemVariantsResponse && itemVariantsResponse.itemVariants) {
                    setItemVariantOptions(itemVariantsResponse.itemVariants.map(variant => ({
                        name: variant.itemVariantName,
                        id: variant.id,
                    })));
                } else {
                    setItemVariantLookupError("Failed to load active item variants for dropdown.");
                }

                if (isEditing || isShowingDetails) {
                    const data = await itemVariantPackageService.getItemVariantPackageById(tenantId, itemVariantPackageId, token);
                    if (data) {
                        setFormData(data);
                        setGeneratedItemVariantPackageName(data.ItemVariantPackageName); // Initialize generated name from fetched data
                        // Convert Firestore Timestamp objects to JS Date objects if necessary for display
                        if (data.DateAdded && data.DateAdded._seconds) data.DateAdded = new Date(data.DateAdded._seconds * 1000);
                        if (data.DateLastModified && data.DateLastModified._seconds) data.DateLastModified = new Date(data.DateLastModified._seconds * 1000);
                    } else {
                        setError("Item Variant Package not found.");
                        navigate(`/item-variant-packages/tenant/${tenantId}`);
                    }
                } else {
                    if (itemVariantsResponse && itemVariantsResponse.itemVariants.length > 0) {
                        const defaultItemVariant = itemVariantsResponse.itemVariants[0];
                        const defaultFormData = { // NEW: Create default form data
                            ...initialItemVariantPackageState,
                            ItemVariantName: defaultItemVariant.name,
                        };
                        setFormData(defaultFormData);
                        // Generated name will be set by the separate useEffect watching formData
                    }
                }
            } catch (err) {
                console.error("Error fetching data for item variant package form:", err);
                setError(`Failed to load data: ${err.message}`);
                setItemVariantLookupError(`Failed to load item variants: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [tenantId, itemVariantPackageId, isAdding, isEditing, isShowingDetails, navigate, auth, constructItemVariantPackageName]);


    const handleChange = (e) => {
        if (isShowingDetails || !canEdit) return;

        const { name, value, type, checked } = e.target;
        
        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked }));
        } else if (name === 'QTY') {
            const floatValue = parseFloat(value);
            setFormData(prev => ({ ...prev, [name]: isNaN(floatValue) ? value : floatValue }));

            // NEW v00b: Real-time validation for QTY
            if (!isNaN(floatValue) && floatValue <= 0) {
                setQtyError("QTY must be greater than 0.");
            } else if (isNaN(floatValue) && value !== '') { // Allow empty string initially, but not non-numeric text
                setQtyError("QTY must be a number.");
            }
            else {
                setQtyError(null);
            }

        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setGeneratedNameError(null); // Clear error for generated name
        setSkuError(null);
        setUpcError(null);
        setQtyError(null); // NEW ver 00b: Clear QTY error on submit
        setItemVariantLookupError(null);

        if (isShowingDetails || !canEdit) {
            setError("You do not have permission to perform this action.");
            return;
        }
        if (!tenantId) {
            setError("Tenant ID missing. Cannot save item variant package.");
            return;
        }

        // Frontend Validation
        if (!formData.ItemVariantName || formData.ItemVariantName.trim() === '') {
            setItemVariantLookupError("Item Variant is required.");
            return;
        }
        if (isNaN(formData.QTY) || parseFloat(formData.QTY.toFixed(2)) !== formData.QTY) {
            setQtyError("QTY must be a number with up to 2 decimal places.");
            return;
        }

        if (formData.QTY <= 0) {
            setQtyError("QTY must be a number greater than zero.");
            return;
        }


        if (!formData.UOM || !allowedUnitPackagingUOMs.includes(formData.UOM)) {
            setError("UOM is required and must be a valid option.");
            return;
        }
        if (!formData.Package || !allowedUnitPackagings.includes(formData.Package)) {
            setError("Package is required and must be a valid option.");
            return;
        }
        if (!formData.ChefsRating || !allowedChefsRatings.includes(formData.ChefsRating)) {
            setError("Chefs Rating is required and must be a valid option.");
            return;
        }
        if (typeof formData.ChefsNotes !== 'string') {
            setError("Chefs Notes must be a string.");
            return;
        }
        if (!formData.SKU || formData.SKU.trim() === '') {
            setSkuError("SKU is required.");
            return;
        }
        if (!formData.UPC || formData.UPC.length !== 12 || !/^\d+$/.test(formData.UPC)) {
            setUpcError("UPC is required and must be a 12-digit string.");
            return;
        }
        if (!formData.Status || !itemVariantPackageStatuses.includes(formData.Status)) {
            setError("Status is required and must be a valid option.");
            return;
        }
        
        try {
            const token = await auth.getIdToken();
            if (!token) {
                setError("Authentication required. Please log in.");
                return;
            }

            const payload = { ...formData };
            payload.QTY = parseFloat(payload.QTY); // Ensure QTY is a number

            // The backend expects ItemVariantPackageName in the payload for uniqueness check
            // Even though it's generated, we send the client-generated version for backend to re-validate
            payload.ItemVariantPackageName = generatedItemVariantPackageName;


            if (isEditing) {
                await itemVariantPackageService.updateItemVariantPackage(tenantId, itemVariantPackageId, payload, token);
                alert("Item Variant Package updated successfully!");
            } else {
                await itemVariantPackageService.addItemVariantPackage(tenantId, payload, token);
                alert("Item Variant Package created successfully!");
            }
            navigate(`/item-variant-packages`);
        } catch (err) {
            console.error("Error saving item variant package via Cloud Function:", err);
            if (err instanceof ApiError && err.status === 409) {
                // Specific error for generated name conflict
                if (err.message.includes('Item Variant Package Name')) setGeneratedNameError(`Error: ${err.message}`);
                else if (err.message.includes('SKU')) setSkuError(`Error: ${err.message}`);
                else if (err.message.includes('UPC')) setUpcError(`Error: ${err.message}`);
                else setError(`Failed to save item variant package: ${err.message}`);
            } else {
                setError(`Failed to save item variant package: ${err.message}`);
            }
        }
    };

    if (loading) return <p>Loading item variant package details...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!tenantId) return <p className="container" style={{ color: 'red' }}>Error: Tenant ID is required to add/edit item variant package.</p>;


    return (
        <div className="container form-container">
            <h2>
                {isAdding && 'Add New Item Variant Package (Tenant: '}
                {isEditing && `Edit Item Variant Package (Tenant: `}
                {isShowingDetails && `Item Variant Package Details (Tenant: `}
                {tenantId})
            </h2>
            {!canEdit && (isEditing || isAdding || isShowingDetails) && (
                <p style={{ color: 'orange', marginBottom: '1rem' }}>You are viewing this record in read-only mode. Contact an administrator to gain editing permissions.</p>
            )}
            <form onSubmit={handleSubmit}>
                {(isEditing || isShowingDetails) && formData.PkgSeqId && (
                    <div className="form-group">
                        <label>Sequential ID</label>
                        <input type="text" name="PkgSeqId" value={formData.PkgSeqId || ''} disabled />
                    </div>
                )}
                
                <div className="form-group">
                    <label>Item Variant</label>
                    <select
                        name="ItemVariantName"
                        value={formData.ItemVariantName}
                        onChange={handleChange}
                        required
                        disabled={isShowingDetails || !canEdit || (itemVariantOptions.length === 0 && !itemVariantLookupError && loading)}
                    >
                        <option value="">-- Select an Item Variant --</option>
                        {itemVariantOptions.map(variant => (
                            <option key={variant.id} value={variant.name}>{variant.name}</option>
                        ))}
                    </select>
                    {itemVariantLookupError && <p style={{ color: 'red', fontSize: '0.85em' }}>{itemVariantLookupError}</p>}
                </div>

                <div className="form-group">
                    <label>QTY</label>
                    <input
                        type="number"
                        step="0.01"
                        name="QTY"
                        value={formData.QTY}
                        onChange={handleChange}
                        required
                        disabled={isShowingDetails || !canEdit}
                    />
                    {qtyError && <p style={{ color: 'red', fontSize: '0.85em' }}>{qtyError}</p>} {/* NEW ver 00b: Display QTY error */}
                </div>

                <div className="form-group">
                    <label>UOM</label>
                    <select name="UOM" value={formData.UOM} onChange={handleChange} required disabled={isShowingDetails || !canEdit}>
                        {allowedUnitPackagingUOMs.map(uom => (
                            <option key={uom} value={uom}>{uom}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Package</label>
                    <select name="Package" value={formData.Package} onChange={handleChange} required disabled={isShowingDetails || !canEdit}>
                        {allowedUnitPackagings.map(pkg => (
                            <option key={pkg} value={pkg}>{pkg}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>VrtPkgNm</label> {/* Auto-generated and disabled */}
                    <input type="text" name="ItemVariantPackageName" value={generatedItemVariantPackageName || ''} disabled />
                    {generatedNameError && <p style={{ color: 'red', fontSize: '0.85em' }}>{generatedNameError}</p>}
                </div>

                <div className="form-group">
                    <label>Chefs Rating</label>
                    <select name="ChefsRating" value={formData.ChefsRating} onChange={handleChange} required disabled={isShowingDetails || !canEdit}>
                        {allowedChefsRatings.map(rating => (
                            <option key={rating} value={rating}>{rating}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Chefs Notes</label>
                    <textarea name="ChefsNotes" value={formData.ChefsNotes} onChange={handleChange} rows="3" disabled={isShowingDetails || !canEdit}></textarea>
                </div>
                
                <div className="form-group">
                    <label>SKU</label>
                    <input type="text" name="SKU" value={formData.SKU} onChange={handleChange} required disabled={isShowingDetails || !canEdit} />
                    {skuError && <p style={{ color: 'red', fontSize: '0.85em' }}>{skuError}</p>}
                </div>

                <div className="form-group">
                    <label>UPC</label>
                    <input type="text" name="UPC" value={formData.UPC} onChange={handleChange} required disabled={isShowingDetails || !canEdit} />
                    {upcError && <p style={{ color: 'red', fontSize: '0.85em' }}>{upcError}</p>}
                </div>

                <div className="form-group">
                    <label>Status</label>
                    <select name="Status" value={formData.Status} onChange={handleChange} required disabled={isShowingDetails || !canEdit}>
                        {itemVariantPackageStatuses.map(status => (
                            <option key={status} value={status}>{status}</option>
                        ))}
                    </select>
                </div>

                {(isEditing || isShowingDetails) && formData.DateAdded && (
                    <div className="form-group">
                        <label>Date Added</label>
                        <input type="text" value={formData.DateAdded instanceof Date ? formData.DateAdded.toLocaleString() : (formData.DateAdded._seconds * 1000).toLocaleString()} disabled />
                    </div>
                )}
                {(isEditing || isShowingDetails) && formData.DateLastModified && (
                    <div className="form-group">
                        <label>Date Last Modified</label>
                        <input type="text" value={formData.DateLastModified instanceof Date ? formData.DateLastModified.toLocaleString() : (formData.DateLastModified._seconds * 1000).toLocaleString()} disabled />
                    </div>
                )}

                {isShowingDetails && canEdit && (
                    <button type="button" className="danger" onClick={() => navigate(`/item-variant-packages/edit/${itemVariantPackageId}`)}>
                        Edit
                    </button>
                )}
                {(isAdding || isEditing) && canEdit && (
                    <button type="submit">Save Item Variant Package</button>
                )}
            </form>
        </div>
    );
}

export default ItemVariantPackageForm;